import { FC } from 'react';
import { formLayoutPaddingTop } from './FormLayout.styles';
import Box from 'yoda-ui/Box';

const FormLayoutMidPanel: FC = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      flex="grow"
      flexGrow={ 1 }
      paddingTop={ formLayoutPaddingTop }
      width="85%"
    >
      { children }
    </Box>
  );
};

export default FormLayoutMidPanel;
